export const formatWon = (value?: number | null) => `${Number(value ?? 0).toLocaleString("ko-KR")}원`;

export const formatMonth = (value?: string | null) => {
  if (!value) return "-";
  return value.slice(0, 7);
};

export const currentBillingMonth = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
};

export const statusLabel = (value?: string | null) => {
  const labels: Record<string, string> = {
    unpaid: "미납",
    partial_paid: "부분납",
    paid: "완납",
    complete: "정상",
    partial: "부분",
    missing: "결측",
    anomaly: "확인필요",
    active_default: "전역정책",
    active_override: "개별정책",
    disabled: "비활성",
    no_policy: "정책없음",
  };
  return value ? labels[value] ?? value : "-";
};
